import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/images/12 1.png";
import pay1 from "../assets/images/13 14.png";
import pay2 from "../assets/images/13 13.png";
import pay3 from "../assets/images/13 12.png";
import axios from "../appUtils/axiosConfig";
import SocialIconBadge from "../social/socialIcons";
import { safeUrl } from "../lib/sanitize";

export default function Footer() {

  
function normalizeList(data) {

  if (Array.isArray(data)) return data;

  if (Array.isArray(data?.data)) return data.data;
  return [];
}
   const [links, setLinks] = useState([]);
   const [loading, setLoading] = useState(true);
   
    const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get("social_links/get_active_social_links.php");
     
      const list = normalizeList(res?.data);
      setLinks(
        Array.isArray(list)
          ? list.sort((a, b) => (Number(a.order_num) || 0) - (Number(b.order_num) || 0))
          : []
      );
    } catch (err) {
    
      setLinks([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div className="container-fluid bg-[#fbeaca] pt-5 mt-5 pb-5 font-archivo">
      <footer className="text-dark">
        <div className="container-fluid px-5">
          <div className="row">
            {/* First Column: Logo and Paragraph */}
            <div className="col-md-5">
              <Link className="navbar-brand pt-0 mt-0" to="/">
                <img
                  src={logo}
                  alt="Sanjeevika Logo"
                  className="logo pt-0"
                  loading="lazy"
                  decoding="async"
                  style={{
                    maxWidth: "100%",
                    marginTop: "-3rem",
                    height: "154px",
                    width: "239px",
                  }}
                />
              </Link>
              <p
                className="log-text text-center-mobile"
                style={{ marginTop: "-2rem" }}
              >
                Divya Jyoti Foundation (DJF) is a socio-spiritual organization
                founded by His Holiness Shri Ashutosh Maharaj ji. It aims at
                providing livelihood to the under privileged and neglected
                sections of the society and inculcates spiritual values among
                them.
              </p>
            </div>

            {/* Second Column: About */}
            <div className="col-md-3">
              <h5 className="text-left text-center-mobile">About</h5>
              <ul className="list-unstyled text-left text-center-mobile">
                <li>C-74/1, ph-2, Vijay Vihar</li>
                <li>Near Rohini Sector-4</li>
                <li>New Delhi, Delhi India 110085</li>
              </ul>

              <div className="mt-2 text-left text-center-mobile mobile-images flex">
                {links.map((link) => (
                  <a
                    key={link.id}
                    href={safeUrl(link.url)}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={link.name}
                    className="mx-1"
                  >
                    {link.icon_image? (
                      <img
                        src={link.icon_image}
                        alt={link.name}
                        loading="lazy"
                        decoding="async"
                      />
                    ):(
                       <SocialIconBadge
                              platform={link.platform}
                              iconImage={link.icon_image}
                              size="md"
                            />
                    )}
                     
                  </a>
                ))}
              </div>
            </div>

            {/* Third Column: Useful Links */}
            <div className="col-md-2">
              <h5 className="text-left text-center-mobile">Useful Links</h5>
              <ul className="list-unstyled text-left text-center-mobile">
                <li>
                  <Link
                    to="/privacy-policy"
                    className="text-dark text-decoration-none hover:text-[#77C712] transition-colors"
                  >
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link
                    to="/return-refunds"
                    className="text-dark text-decoration-none hover:text-[#77C712] transition-colors"
                  >
                    Return & Refunds
                  </Link>
                </li>
                <li>
                  <Link
                    to="/terms-and-conditions"
                    className="text-dark text-decoration-none hover:text-[#77C712] transition-colors"
                  >
                    Terms & Condition
                  </Link>
                </li>
                <li>
                  <Link
                    to="/shipping-policy"
                    className="text-dark text-decoration-none hover:text-[#77C712] transition-colors"
                  >
                    Shipping Policy
                  </Link>
                </li>
              </ul>
            </div>

            {/* Fourth Column: My Account */}
            <div className="col-md-2">
              <h5 className="text-left text-center-mobile">My Account</h5>
              <ul className="list-unstyled text-left text-center-mobile">
                <li>
                  <Link
                    to="/login"
                    className="text-dark text-decoration-none hover:text-[#77C712] transition-colors"
                  >
                    Sign In
                  </Link>
                </li>
                <li>
                  <Link
                    to="/profile"
                    className="text-dark text-decoration-none hover:text-[#77C712] transition-colors"
                  >
                    Order History
                  </Link>
                </li>
                <li>
                  <Link
                    to="/cart"
                    className="text-dark text-decoration-none hover:text-[#77C712] transition-colors"
                  >
                    View Cart
                  </Link>
                </li>
                <li>
                  <Link
                    to="/wish-list"
                    className="text-dark text-decoration-none hover:text-[#77C712] transition-colors"
                  >
                    My Wishlist
                  </Link>
                </li>
                <li>
                  <Link
                    to="/profile"
                    className="text-dark text-decoration-none hover:text-[#77C712] transition-colors"
                  >
                    Track My Order
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <hr />

          {/* Payment Icons */}
          <div className="row justify-content-center">
            <div className="col-md-6 col-sm-12">
              <div className="flex flex-wrap justify-center gap-4">
                <img
                  src={pay1}
                  alt="Pay"
                  loading="lazy"
                  decoding="async"
                  className="max-w-[100px] sm:max-w-[120px] md:max-w-[136px]"
                />
                <img
                  src={pay2}
                  alt="UPI"
                  loading="lazy"
                  decoding="async"
                  className="max-w-[100px] sm:max-w-[120px] md:max-w-[136px]"
                />
                <img
                  src={pay3}
                  alt="PhonePe"
                  loading="lazy"
                  decoding="async"
                  className="max-w-[100px] sm:max-w-[120px] md:max-w-[136px]"
                />
              </div>
            </div>
          </div>

          <div className="text-center mt-3">
            <p>Made with love in India, powered by<a href="https://squibfactory.com/" target="_blank" rel="noopener noreferrer" className="text-[#77C712] hover:text-[#5a9a0f] transition-colors"> Squibfactory</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
}
